<template>
  <button
    type="button"
    class="pamia-fab position-fixed rounded-circle border-0 bg-white text-white d-flex d-md-none align-items-center justify-content-center"
    aria-label="Falar com a Pamia"
    @click="openModal"
  >
    <!-- <i class="fa-solid fa-face-smile fa-lg"></i> -->
    <img src="@/assets/img/pamia.png" alt="" height="35" />
  </button>

  <ModalComponent
    id="pamia-modal"
    :backdrop="'true'" modalClass="pamia-modal text-primary"
    size="pamia-modal-dialog"
    bodyClass="p-0 d-flex flex-column"
    @modalClosed="handleModalClosed"
  >
    <template v-slot:body>
      <LoadingContainer v-if="loadingUrl" />
      <iframe
        v-else-if="iframeUrl"
        :src="iframeUrl"
        frameborder="0"
        class="flex-fill w-100 border-0"
      ></iframe>
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import { pamiaChatRepo } from "@/di/repositories";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";

const { session: userSession } = storeToRefs(useSessionStore());
const iframeUrl = ref("");
const loadingUrl = ref(true);

async function loadUrl() {
  loadingUrl.value = true;
  iframeUrl.value = "";
  if (!userSession.value) {
    // visitante usa a página pública da Pamia
    iframeUrl.value = `${process.env.VUE_APP_API_BASE_URL}pamia`;
    loadingUrl.value = false;
    return;
  }
  try {
    iframeUrl.value = (await pamiaChatRepo.getWebviewUrl()).url;
  } catch (e: any) {
    EventBus.$emit(EventBusNames.SHOW_ERROR_TOAST, {
      msg: e?.message || "Não foi possível abrir a Pamia, tente novamente",
    });
  } finally {
    loadingUrl.value = false;
  }
}

function openModal() {
  toggleModal("pamia-modal");
  loadUrl();
}
// no desktop a Pamia abre pelo item da navbar (OPEN_PAMIA); no celular, pelo botão flutuante
onMounted(() => EventBus.$on(EventBusNames.OPEN_PAMIA, openModal));
onBeforeUnmount(() => EventBus.$off(EventBusNames.OPEN_PAMIA, openModal));
const handleModalClosed = () => {
  iframeUrl.value = "";
};
</script>

<style scoped>
.pamia-fab {
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  z-index: 1030;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}
</style>

<!--
  ModalComponent has multiple root nodes (the .modal div + a hidden trigger button),
  so Vue can't forward this component's scope attribute onto it for `:deep()` to reach.
  These rules target it by its unique #pamia-modal id instead, unscoped.
-->
<style>
#pamia-modal .modal-dialog {
  max-width: 420px !important;
  height: 85vh !important;
}

/* o X fica um pouco para fora da caixa: o modal-dialog-scrollable cortava (overflow: hidden) */
#pamia-modal .modal-content {
  overflow: visible !important;
  height: 100% !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

#pamia-modal .modal-header {
  position: absolute !important;
  top: 8px !important;
  right: 8px !important;
  z-index: 2 !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
}

#pamia-modal .modal-header i {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 28px !important;
  height: 28px !important;
  border-radius: 50% !important;
  background: #123766 !important;
  color: #fff !important;
  font-size: 14px !important;
  position: absolute;
  top: -14px;
  right: -14px;
}

/* no celular o modal ganha margem para o X (que fica um pouco para fora) caber na tela */
@media (max-width: 575.98px) {
  #pamia-modal .modal-dialog {
    margin: 24px 20px !important;
    height: calc(100dvh - 48px) !important;
    min-height: 0 !important;
  }
}

#pamia-modal .modal-body {
  height: 100% !important;
  overflow: hidden !important;
  border-radius: 1rem;
  background-color: #fff;
  justify-content: center;
}
</style>
